<template>
  <v-container fluid>
        <v-row>
      <v-col cols="12">
        <div class="video-wrapper synthesis-section-border-radius">
          <div class="video-container">
            <iframe
              src="https://www.youtube.com/embed/0V3AlOSdyaA?autoplay=1&mute=1&loop=1&playlist=0V3AlOSdyaA&controls=0&showinfo=0&modestbranding=1"
              frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
          </div>
          <div class="video-overlay"></div>
          <div class="video-content text-center">
            <v-row justify="center">
              <v-col cols="12">
                <div class="d-inline-block" style="max-width: 650px;">
                  <h1 :class="headerTitleClass" class="synthesis-brand-lightest-blue--text">
                    Risk management made simple.
                  </h1>

                  <h2 :class="headerSubTitleClass" class="synthesis-brand-lightest-blue--text py-6">
                    Design hedging strategies in real time with live data and stay updated with all market developments.
                  </h2>
                </div>
              </v-col>

              <v-col cols="12">
                <v-btn class="synthesis-brand-dark-blue--text" color="white" depressed height="42" width="110"
                  :to="{ name: 'ContactUs' }" v-text="$t('Common.Button.ContactUs')" />
              </v-col>
            </v-row>

          </div>
        </div>
      </v-col>
    </v-row>
    <!-- <v-row no-gutters>
      <v-col cols="12" class="pa-0">
        <div class="video-wrapper">
          <iframe
            src="https://www.youtube.com/embed/0V3AlOSdyaA?autoplay=1&mute=1&loop=1&playlist=0V3AlOSdyaA&controls=0&showinfo=0&modestbranding=1"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
          <div class="video-overlay"></div>
          <div class="video-content text-center">
            <v-row justify="center">
              <v-col cols="12">
                <div class="d-inline-block" style="max-width: 650px">
                  <h1
                    :class="headerTitleClass"
                    class="synthesis-brand-lightest-blue--text"
                  >
                    Risk management made simple.
                  </h1>

                  <h2
                    :class="headerSubTitleClass"
                    class="synthesis-brand-lightest-blue--text py-6"
                  >
                    Design hedging strategies in real time with live data and
                    stay updated with all market developments.
                  </h2>
                </div>
              </v-col>

              <v-col cols="12">
                <v-btn
                  class="synthesis-brand-dark-blue--text"
                  color="white"
                  depressed
                  height="42"
                  width="110"
                  :to="{ name: 'ContactUs' }"
                  v-text="$t('Common.Button.ContactUs')"
                />
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
    </v-row> -->

    <v-row>
      <v-col cols="12">
        <v-card
          class="white pa-4 pa-md-8 pa-lg-16 synthesis-section-border-radius fill-height"
          flat
        >
          <v-container class="text-center" fluid>
            <v-row>
              <v-col cols="12">
                <div class="d-inline-block" style="max-width: 465px">
                  <h1
                    :class="sectionTitleClass"
                    class="synthesis-brand-dark-blue--text"
                  >
                    Risk Management
                  </h1>

                  <h2
                    :class="sectionSubTitleClass"
                    class="synthesis-brand-dark-blue--text py-6"
                  >
                    3 step journey to enlightenment with
                    <img
                      height="20"
                      width="20"
                      style="vertical-align: text-bottom"
                      src="/img/logo/logo-symbol.png"
                    />
                    Synthesis
                  </h2>
                </div>
              </v-col>

              <v-col cols="12">
                <div class="video-container-responsive">
                  <video
                    src="/videos/3-steps-final.mp4"
                    autoplay
                    muted
                    playsinline
                    preload="auto"
                    style="width: 100%; height: auto; background-color: white"
                  ></video>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card
          class="synthesis-ui-blue-02 pa-1 pa-md-3 pa-lg-6 pb-0 pb-md-0 pb-lg-0 synthesis-section-border-radius"
          flat
        >
          <v-container class="text-center py-10" fluid>
            <v-row>
              <v-col cols="6" class="d-flex align-center justify-center">
                <div class="d-inline-block" style="max-width: 550px">
                  <h1
                    :class="sectionTitleClass"
                    class="synthesis-brand-lightest-blue--text"
                  >
                    Secure the future of your business from just one screen
                  </h1>

                  <h2
                    :class="sectionSubTitleClass"
                    class="synthesis-brand-lightest-blue--text py-6"
                  >
                    Get key information on your live exposures, active risk
                    profile and MTM of hedging positions from your dashboard.
                  </h2>
                </div>
              </v-col>

              <v-col class="py-12" cols="6">
                <div class="screen-tilt-wrapper">
                  <v-img
                    class="screen-tilt-image"
                    height="auto"
                    max-width="802"
                    src="/img/bg/section-1.png"
                    width="100%"
                  />
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <v-card
          class="white pa-4 pa-md-8 pa-lg-16 synthesis-section-border-radius fill-height"
          flat
        >
          <v-container class="text-center" fluid>
            <v-row>
              <v-col cols="12">
                <div class="d-inline-block" style="max-width: 465px">
                  <h1
                    :class="sectionTitleClass"
                    class="synthesis-brand-dark-blue--text"
                  >
                    Simple and Precise Risk and Hedging Reports
                  </h1>

                  <h2
                    :class="sectionSubTitleClass"
                    class="synthesis-brand-dark-blue--text py-6"
                  >
                    Automatically update your current and forecasted exposures,
                    run bespoke risk reports and produce the optimal hedging
                    strategies.
                  </h2>
                </div>
              </v-col>

              <v-col cols="12">
                <risk-donut-chart />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card
          class="synthesis-ui-orange-01 pa-4 pa-md-8 pa-lg-16 synthesis-section-border-radius fill-height"
          flat
        >
          <v-container class="text-center" fluid>
            <v-row>
              <v-col cols="12">
                <div class="d-inline-block" style="max-width: 465px">
                  <h1 :class="sectionTitleClass" class="white--text">
                    Benchmark against your peers
                  </h1>

                  <h2 :class="sectionSubTitleClass" class="white--text py-6">
                    Compare different hedging approaches across multiple
                    industries and understand how companies hedge within your
                    sector.
                  </h2>
                </div>
              </v-col>

              <v-col cols="12">
                <benchmark-bar-chart />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <v-card
          class="synthesis-ui-green-00 pa-4 pa-md-8 pa-lg-16 synthesis-section-border-radius fill-height"
          flat
        >
          <v-container class="text-center" fluid>
            <v-row>
              <v-col cols="12">
                <div class="d-inline-block" style="max-width: 460px">
                  <h1 :class="sectionTitleClass" class="white--text">
                    Don’t get caught unaware during a crisis
                  </h1>

                  <h2 :class="sectionSubTitleClass" class="white--text py-6">
                    Use advanced tools powered by AI to observe your cross asset
                    risk profile in real time and also monitor the live MTM of
                    all your hedge positions.
                  </h2>
                </div>
              </v-col>

              <v-col cols="12">
                <hedging-positions-chart />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card
          class="white pa-4 pa-md-8 pa-lg-16 synthesis-section-border-radius fill-height"
          flat
        >
          <v-container class="text-center" fluid>
            <v-row>
              <v-col cols="12">
                <div class="d-inline-block" style="max-width: 485px">
                  <h1
                    :class="sectionTitleClass"
                    class="synthesis-brand-dark-blue--text"
                  >
                    Stay up to date as market conditions change the profile of
                    your risk
                  </h1>

                  <h2
                    :class="sectionSubTitleClass"
                    class="synthesis-brand-dark-blue--text py-6"
                  >
                    From 24hr alerts to live data and MTM, Synthesis provides
                    clear guidance on hedging risk in real time.
                  </h2>
                </div>
              </v-col>

              <v-col cols="12">
                <div style="max-width: 350px; margin: 0 auto">
                <optimal-hedge-chart />
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card
          class="synthesis-ui-blue-02 pa-4 pa-md-8 pa-lg-16 synthesis-section-border-radius"
          flat
        >
          <v-container class="text-center" fluid>
            <v-row>
              <v-col cols="12" class="pb-6">
                <div class="d-inline-block" style="max-width: 465px">
                  <h1
                    :class="sectionTitleClass"
                    class="synthesis-brand-lightest-blue--text"
                  >
                    Synthesis at a glance
                  </h1>
                </div>
              </v-col>

              <v-col cols="12">
                <div class="video-container-responsive">
                  <div
                    style="position: relative; width: 100%; padding-top: 56.25%"
                  >
                    <iframe
                      style="
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        border: 0;
                      "
                      src="https://www.youtube.com/embed/kt9zV-PHe3U?controls=1&showinfo=0&modestbranding=1&rel=0"
                      frameborder="0"
                      allow="fullscreen"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card
          class="synthesis-ui-blue-02 pa-0 pa-md-8 pa-lg-16 py-0 py-md-0 py-lg-0 synthesis-section-border-radius"
          flat
          height="550"
        >
          <v-img height="550" src="/img/bg/card-bg.png">
            <v-container
              class="fill-height text-center align-center justify-center"
              fluid
            >
              <v-row>
                <v-col cols="12">
                  <div class="d-inline-block" style="max-width: 780px">
                    <h1
                      :class="headerTitleClass"
                      class="synthesis-brand-lightest-blue--text"
                    >
                      Get started today and secure your business.
                    </h1>

                    <h2
                      :class="headerSubTitleClass"
                      class="synthesis-brand-lightest-blue--text py-6"
                    >
                      Speak to a member of our team today to get started with
                      Synthesis and be confident you are on top of your risk
                      during both calm periods and market crises!
                    </h2>
                  </div>
                </v-col>

                <v-col cols="12">
                  <v-btn
                    class="synthesis-brand-dark-blue--text"
                    color="white"
                    depressed
                    height="42"
                    width="110"
                    :to="{ name: 'ContactUs' }"
                    v-text="$t('Common.Button.ContactUs')"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-img>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import i18nRouteMeta from '@/mixins/i18n/i18nRouteMeta'
import CssClassFontSizes from '@/mixins/cssClassFontSizes'
import RiskDonutChart from './RiskDonutChart'
import BenchmarkBarChart from './BenchmarkBarChart'
import HedgingPositionsChart from './HedgingPositionsChart'
import OptimalHedgeChart from './OptimalHedgeChart'

export default {
  name: 'Home',
  components: { RiskDonutChart, BenchmarkBarChart, HedgingPositionsChart, OptimalHedgeChart },
  directives: {},
  mixins: [i18nRouteMeta, CssClassFontSizes],
  props: {},
  dataStore: {},
  enums: {},
  data () {
    return {}
  },
  computed: {},
  watch: {},
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    showContactDialog () {
      this.$bus.$emit('Dialog:Contact:Show')
    }
  }
}
</script>

<style scoped>
.video-wrapper {
  position: relative;
  width: 100%;
  height: 80vh;
  overflow: hidden;
  border-radius: var(--v-border-radius-lg, 16px);
}

@media (max-width: 960px) {
  .video-wrapper {
    height: 40vh;
  }
}

.video-wrapper iframe {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 120vw;
  height: 120vh;
  transform: translate(-50%, -50%);
  border: 0;
  object-fit: cover;
}

.video-overlay {
  position: absolute;
  inset: 0;
  background: rgba(10, 25, 47, 0.65);
  z-index: 2;
  border-radius: inherit;
}

.video-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  width: 100%;
  padding: 0 16px;
}

.screen-tilt-wrapper {
  perspective: 1000px;
  display: flex;
  justify-content: center;
}

.screen-tilt-image {
  transform: rotateX(10deg) rotateY(25deg);
  transform-style: preserve-3d;
  transition: transform 0.5s ease;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
}

.screen-tilt-wrapper:hover .screen-tilt-image {
  transform: rotateX(0deg) rotateY(0deg) scale(1.05);
}

.video-container-responsive {
  max-width: 700px;
  margin: 0 auto;
}

@media (min-width: 960px) {
  .video-container-responsive {
    max-width: 900px;
  }
}

@media (min-width: 1264px) {
  .video-container-responsive {
    max-width: 1000px;
  }
}

@media (min-width: 1904px) {
  .video-container-responsive {
    max-width: 1200px;
  }
}
</style>
